<template>
  <div v-if="route.meta && route.meta.breadcrumb" class="white-bg">
    <div class="breadcrumb center mx3 flex">
      <i class="breadcrumb-arrow icon-angle-left-icon red bold flex items-center pointer" @click="router.replace({name: routeInfo.parentName})"></i>
      <span class="h4n semi-bold flex flex-wrap items-center mx1 center mx-auto">{{ getReferencelabel(breadCrumbTitle) }}</span>
    </div>
  </div>
</template>
<script>

import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { findRouteInformation, getReferencelabel } from '@/mixins/utils';

export default {
  setup () {
    const route = useRoute();
    const router = useRouter();

    const routeInfo = computed(() => findRouteInformation(route.name));

    const breadCrumbTitle = computed(() => (route.meta && route.meta.reference ? route.meta.reference.toUpperCase() : null));

    return { route, router, routeInfo, breadCrumbTitle, getReferencelabel };
  }
};
</script>

<style>

.breadcrumb {
  background-color: white;
  border-bottom: 2px solid #00a6c6;
  min-height: 70px;
  height: 70px;
}

.breadcrumb-arrow {
  font-size: 35px;
  color:red;
}
</style>
